"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = void 0;

var _escape = require("../escape/escape");

/**
 * Make safe for RegExp'ing
 *
 * @param   {string}  source  Source string
 *
 * @return  {string}
 *
 * @tag String
 * @signature ( source: string ): string
 *
 * @example { example }
 *
 * escapeRegExp( "lorem. ipsum [dolor]" )
 * // => "lorem \\. ipsum \\[dolor\\]"
 */
var escapeRegExp = (0, _escape.escape)(/[$()*+.<>?[\\\]^{|}]/g);
exports.escapeRegExp = escapeRegExp;